import { useState, type FormEvent } from "react";
import { supabase } from "@/lib/supabase";
import { mapearErrorSupabase } from "@/lib/errores";
import { Boton, Campo, Input } from "@/components/ui";
import { Logo } from "@/components/layout/Logo";

export function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [cargando, setCargando] = useState(false);

  async function enviar(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setCargando(true);
    const { error } = await supabase.auth.signInWithPassword({ email: email.trim(), password });
    setCargando(false);
    if (error) setError(mapearErrorSupabase(error).mensaje);
  }

  return (
    <main className="flex min-h-full items-center justify-center bg-sidebar p-6">
      <form onSubmit={enviar} className="w-full max-w-sm rounded-lg bg-white p-8 shadow-xl">
        <div className="mb-6 flex items-center gap-3">
          <Logo className="h-10 w-10" />
          <div>
            <h1 className="text-xl font-bold leading-tight">EYE IA</h1>
            <p className="text-sm text-tinta-suave">Control de almacén</p>
          </div>
        </div>
        <div className="space-y-4">
          <Campo etiqueta="Correo" htmlFor="email">
            <Input id="email" type="email" autoComplete="username" inputMode="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@empresa.com" />
          </Campo>
          <Campo etiqueta="Contraseña" htmlFor="password" error={error ?? undefined}>
            <Input id="password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
          </Campo>
          <Boton type="submit" className="w-full" tamano="lg" cargando={cargando}>Entrar</Boton>
          <p className="text-center text-sm text-tinta-suave">¿No tienes acceso? Pídeselo al administrador de tu empresa.</p>
        </div>
      </form>
    </main>
  );
}
